import * as Sentry from "@sentry/react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

Sentry.init({
  dsn: "https://f0e502f21f95a1005a561f6927f5e632@o4511174597869568.ingest.us.sentry.io/4511174600425472",
  environment: import.meta.env.MODE,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration({
      // Capture 10% of sessions, 100% of sessions with errors
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  // Performance: 10% of transactions in prod, 100% in dev
  tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
  // Session Replay: 5% of normal sessions, 100% of error sessions
  replaysSessionSampleRate: 0.05,
  replaysOnErrorSampleRate: 1.0,
});

createRoot(document.getElementById("root")!).render(<App />);
